module.exports = __webpack_public_path__ + "img/warning.1c73752f.svg";